let uuid = null

export const setUuid = (id) => uuid = id

export function getOrgUuid() {
  return uuid || process.env.GATSBY_ORG_UUID
}
